module.exports = __webpack_public_path__ + "img/logo.525d878c.png";